import i18n from 'i18next';
import { getDecimal } from '../../../shared/components/chart/chart-helpers';
import { getState } from '../../../utils/state';
import AnalysisGeographical from '../geographical/analysis-geographical';
import { Utils } from '../../../utils/utils';
import { getUnit } from '../../../shared/components/chart/chart-helpers';

import { getUrlParams, setUrlParam } from '../../../utils/url';
import { html, render } from 'lit-html';
import { debounce } from 'underscore';

const GeoChart = (analysis, indicatorInfo, data, datevalue = true) => {
  const indicator = indicatorInfo.indicator;
  const { level, zoom, latlng, geoids } = getUrlParams();
  // Getting global common state
  let indicatorName = '',
    geosArr = '';
  if (state?.analysis?.indicator) {
    geosArr = state.analysis.indicator.geos;
    indicatorName = state.analysis.indicator.name;
  }
  let foundGeo = geoids && geosArr.find((el) => el.geo_id == geoids)?.geo_name;
  let preLatLang = latlng
    ? latlng.includes(',')
      ? latlng.split(',')
      : latlng.split('%2C')
    : [40, -3];
  const state = getState();
  let defaults = {
    colors: [
      '#ffffcc',
      '#c7e9b4',
      '#7fcdbb',
      '#41b6c4',
      '#1d91c0',
      '#225ea8',
      '#0c2c84',
    ],
    map: {
      center: preLatLang,
      zoom: zoom || 6,
      maxZoom: 9,
      scrollWheelZoom: false,
    },
    tiles: {
      // url: 'https://cartocdn_{s}.global.ssl.fastly.net/base-light/{z}/{x}/{y}.png',
      url: `${window.location.origin}/images_temp/maps/{z}/{x}/{y}.png`,
    },
    sql: {
      user: 'maps',
      format: 'json',
      jsonp: true,
      sql_api_template: 'https://ree-admin.carto.com',
    },
    cartodb: {
      user_name: 'maps-admin',
      type: 'cartodb',
      cartodb_logo: true,
      maps_api_template: 'https://ree-admin.carto.com',
      sublayers: [],
    },
    indicatorId: indicatorInfo.indicator.id,
    composited: indicatorInfo.indicator.composited,
    unit: getUnit(indicatorInfo.indicator.magnitud[0].id),
    decimal: getDecimal(indicatorInfo.indicator.magnitud[0].id) || 1,
    title: foundGeo ? `${indicatorName} ${foundGeo}` : '',
    currentIndicator: indicatorInfo.indicator,
    currentGeoIds: indicatorInfo.indicator.geos,
  };
  function calcQuantils(arr, num, opts) {
    let ascending = (a, b) => {
      return a - b;
    };
    var len = arr.length,
      qValues = new Array(num + 1),
      id,
      val;
    if (!opts.sorted) {
      arr = arr.slice();
      arr.sort(ascending);
    }
    // 0th quantile is the min:
    qValues[0] = arr[0];

    // Max defines the quantile upper bound:
    qValues[num] = arr[len - 1];

    // Get the quantiles...
    for (var i = 1; i < num; i++) {
      // Calculate the vector index marking the quantile:
      id = (len * i) / num - 1;

      // Is the index an integer?
      if (id === Math.floor(id)) {
        // Value is the average between the value at id and id+1:
        val = (arr[id] + arr[id + 1]) / 2.0;
      } else {
        // Round up to the next index:
        id = Math.ceil(id);
        val = arr[id];
      }
      qValues[i] = val;
    } // end FOR i
    return qValues;
  }

  // Current language we are using
  function calculateQuantiles(geoData) {
    if (state.analysis && state.analysis.quantiles) {
      return state.analysis.quantiles;
    } else {
      const maxScale = 7;
      const data = geoData.map((g) => g.total);
      const colors = defaults.colors.reverse();
      var numberOfQuantiles = data.length <= maxScale ? data.length : maxScale;
      let quantiles = [];
      if (numberOfQuantiles <= 1) {
        quantiles = [
          {
            originalValue: data[0],
            value: Math.floor(data[0] / 10) * 10,
            color: colors[0],
            sign: '>',
          },
        ];
        // Else calculing quantils
      } else {
        let quantilesTemp = calcQuantils(data, numberOfQuantiles - 1, {})
          .reverse()
          .map(function (q, i) {
            // Client wish round to 10
            // OLD: var quantilValue = q < 10 ? Math.round(q) : Math.floor(q / 10) * 10;
            var quantilValue = Math.floor(q / 10) * 10;
            return {
              originalValue: q,
              value: quantilValue,
            };
          });
        _.uniq(quantilesTemp, true, 'value').map((q, i) => {
          quantiles.push({ ...q, color: colors[i], sign: '>' });
        });
      }

      return quantiles;
    }
  }

  function addLegend(quantiles, unit) {
    let legend = document.querySelector('#geo-legend');

    var legendData = quantiles.map(function (q) {
      return {
        sign: q.sign,
        value: q.value,
        color: q.color,
        unit: unit ? unit : '',
      };
    });

    function getLegendTemplate(legendData, title, unit) {
      return html`
        <div class="widget-legend basic-legend">
          ${title ? html`<h3>${title}</h3>` : ''}
          <ul>
            ${legendData &&
            legendData.length > 0 &&
            legendData.map((elem) => {
              return html`
                <li class="legend-item item-content">
                  <div class="item">
                    <span
                      class="legend-circle"
                      .style="background-color: ${elem.color};"
                    ></span
                    >${elem.name}
                  </div>
                  <div class="value is-number">
                    <!-- CHECK IF ALWAYS SHOULD BE ZERO -->
                    ${elem.sign} ${Utils.toNumber(elem.value, 0, 'comma')}
                    <span class="unit">${unit}</span>
                  </div>
                </li>
              `;
            })}
          </ul>
        </div>
      `;
    }

    // var clickEventName = window.ontouchstart ? 'touchstart' : 'click';
    render(
      getLegendTemplate(legendData, defaults.title, defaults.unit),
      legend
    );

    legend.classList.remove('is-hidden');
  }
  let quantiles = calculateQuantiles(data);

  addLegend(quantiles, defaults.unit);
};

export default GeoChart;
